import React, { useContext } from "react";
import { makeGet } from "@culturehq/client";

import { usePagedEntity } from "app/hooks";

import * as CHQ from "chq";

type RecognitionTypesState = {
  allRecognitionTypesFetched: boolean;
  onAllRecognitionTypesRequested: () => void;
  onAutocompleteRecognitionTypes: (_query: string) => void;
  onNextRecognitionTypePageRequested: () => void;
  onRecognitionTypesRequested: (_recognitionTypeIds: number[]) => void;
  recognitionTypes: { [key: number]: CHQ.RecognitionType };
};

const RecognitionTypesContext = React.createContext<RecognitionTypesState>({
  allRecognitionTypesFetched: false,
  onAllRecognitionTypesRequested: () => {},
  onAutocompleteRecognitionTypes: () => {},
  onNextRecognitionTypePageRequested: () => {},
  onRecognitionTypesRequested: () => {},
  recognitionTypes: {}
});

const onFetchPage = (page: number) => makeGet("/recognitions/recognition_types", { page });

const onFetchEntity = (recognitionTypeId: number) => (
  makeGet(`/recognitions/recognition_types/${recognitionTypeId}`)
);

const onFetchAutocomplete = (query: string) => (
  makeGet("/autocomplete/recognition_types", { query })
);

export const RecognitionTypesProvider: React.FC = ({ children }) => {
  const value = usePagedEntity("recognitionType", onFetchPage, onFetchEntity, onFetchAutocomplete);

  return (
    <RecognitionTypesContext.Provider value={value as RecognitionTypesState}>
      {children}
    </RecognitionTypesContext.Provider>
  );
};

export const useRecognitionTypes = () => useContext(RecognitionTypesContext);
